import { API } from "config";
import type { Message } from "types/Message";
import request from "utilities/request";

const baseUrl = API.dbApi.url;

interface PutThreadMessagesResponseBody {
  messages: Message[];
  timestamp: string;
}

/**
 * Sets a chat thread's list of messages.
 * Pass `[]` to clear the message list.
 */
export async function putThreadMessages(
  threadId: string,
  messages: Message[],
  getAccessToken: () => Promise<string>
): Promise<PutThreadMessagesResponseBody> {
  const accessToken = await getAccessToken();

  const url = `${baseUrl}/threads/${threadId}/messages`;
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${accessToken}`,
  };
  const options = {
    method: "PUT",
    headers,
    body: JSON.stringify({ messages }),
  };

  const response = await request(url, options);
  return (await response.json()) as PutThreadMessagesResponseBody;
}
